<div class="route-recap">
  <div class="recap-header">
    <div class="recap-title">
      <span class="recap-dot"></span>
      <div>
        <div class="recap-tech">{{ recap.technicianName }}</div>
        <div class="recap-date">{{ recap.dateLabel }}</div>
      </div>
    </div>
    <button
      type="button"
      class="recap-close"
      title="Masquer l'itinéraire"
      (click)="closed.emit()"
    >
      <i class="pi pi-times"></i>
    </button>
  </div>

  @if (recap.summary) {
    <div class="recap-summary">
      <i class="pi pi-car"></i>
      {{ recap.summary }}
    </div>
  }

  @if (loading) {
    <div class="recap-loading">
      <i class="pi pi-spin pi-spinner"></i>
      Calcul de l'itinéraire...
    </div>
  }

  @if (recap.homeDeparture) {
    <div class="recap-home">
      <i class="pi pi-home"></i>
      <span class="home-label">Départ domicile</span>
      <span class="home-time">{{ recap.homeDeparture }}</span>
    </div>
  }

  <ol class="recap-stops">
    @for (stop of recap.stops; track stop.order) {
      <li class="recap-stop">
        <span class="stop-num">{{ stop.order }}</span>
        <div class="stop-body">
          <div class="stop-line">
            <span class="stop-time">{{ stop.time }}</span>
            @if (stop.interventionId && stop.erpSource) {
              <a
                class="stop-fiche"
                [href]="
                  '/intervention/' + stop.interventionId + '/view/' + stop.erpSource
                "
                target="_blank"
                rel="noopener noreferrer"
              >
                <i class="pi pi-eye"></i>
                Voir
              </a>
            }
          </div>
          <div class="stop-title">{{ stop.title }}</div>
          @if (stop.location) {
            <div class="stop-loc">{{ stop.location }}</div>
          }
        </div>
      </li>
    }
  </ol>

  @if (recap.homeReturn) {
    <div class="recap-home">
      <i class="pi pi-home"></i>
      <span class="home-label">Retour domicile</span>
      <span class="home-time">{{ recap.homeReturn }}</span>
    </div>
  }
</div>
